module.exports = __webpack_public_path__ + "static/circled-check-filled.a0825bfd.svg";